import _capitalize from "lodash/capitalize";
import _startCase from "lodash/startCase";
import accounting from "accounting";
import moment from "moment";
const truncate = require("html-truncate");

export function capitalize(text) {
    return _capitalize(text)
}

export function formatNumber(number) {
    return accounting.formatNumber(number);
}

export function formatMoney(number) {
    return accounting.formatMoney(number);
}

export function formatCreditCardExpirationDate(date) {
    return moment(date).format("MM/YY");
}

export function formatDate(date) {
    return moment(date).format("MM/DD/YY");
}

export function titleCase(text) {
    return _startCase(text);
}

export function formatBookReleaseDate(date) {
    return moment(date).format("MMM DD[,] YYYY");
}

export function secondsToHoursMinutes(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);

    const hourDisplay = hours > 0 ? hours + (hours == 1 ? " hr " : " hrs ") : "";
    const minutesDisplay = minutes > 0 ? minutes + (minutes == 1 ? " min " : " mins ") : "";

    return hourDisplay + minutesDisplay;
}

export function resizeCoverUrl(url, width = 220, height = 220) {
    const newUrl = url.split("?")[0];
    return newUrl + `?height=${height}&width=${width}`;
}

export function replaceUrlProtocol(url) {
    return url.replace("http://", "https://");
}

export function formatBookInsightDuration(duration) {
    return moment("2019-01-01 00:00:00").add(duration, "minutes").format(duration < 60 ? "m[ mins]" : (duration % 60 ? "H[ hrs] m[ mins]" : " H[ hrs]"))
}

export function formatHighlightedInsight(date) {
    return moment(date).format("MMMM YYYY");
}

export function truncateText(text, limit) {
    if (!text) {
        return "";
    }
    return truncate(text, limit);
}

